import { PROGRESS_START, PROGRESS_FINISH, PROGRESS_FAIL } from '../../mutation-types';
import transactionApi from '@/api/transaction';
import stockApi from '@/api/stock';
import scanSerialApi from '@/api/scanSerial';

const defaultState = () => ({
    transactionResults: [],
    transactionPagination: [],
    transactionOne: {},
    param: {},
    paramKonfProses: {},
    AlertKonfPickUp: {},
    AlertKonfPickUpMsg: '',
    ProsesOrderAlert: '',
    dataProduct: [],
    serialOwnedList: [],
    cancelReason: ''
});

const state = defaultState();

const getters = {

};

const mutations = {
    setcancelReason(state, data) {
        state.cancelReason = data
    },

    errorProsesOrder(state, data) {
        state.ProsesOrderAlert = data
    },

    resetErrorProsesOrder(state) {
        state.ProsesOrderAlert = ''
    },

    setAlertKonfPickUp(state, data) {
        if (Object.keys(data)) {
            state.AlertKonfPickUp = Object.assign({}, state.AlertKonfPickUp, data);
        } else {
            state.AlertKonfPickUpMsg = data
        }
    },

    resetAlertKonfPickUp(state) {
        state.AlertKonfPickUp = {};
    },

    setKonfProses(state, data) {
        state.paramKonfProses = Object.assign({}, state.paramKonfProses, data);
    },

    listTransaction(state, data) {
        state.transactionResults = data.data;
        state.transactionPagination = data.pagination;
    },

    setSerialOwnedList(state, data) {
        state.serialOwnedList = data
    },

    listTransactionOne(state, data) {
        state.dataProduct = [];
        state.transactionOne = data;
    },

    reset(state) {
        Object.assign(state, defaultState());
    },

    listProduct(state, data) {
        state.dataProduct = data
    },

    removeSelected(state, data) {
        var serial = [...state.dataProduct[data.index].listSelected]
        data.serial.forEach( element => {
            const indexSelected = serial.findIndex(el => el == element)
            if (indexSelected != -1) {
                serial.splice(indexSelected, 1)
            }
        });
        state.dataProduct[data.index].listSelected = serial;
    },
    selectAll(state, data) {
        var serial = [... state.dataProduct]
        if (data.value) {
            serial[data.index].tempSerial = serial[data.index].allSerial
        } else {
            serial[data.index].tempSerial = []
        }
        state.dataProduct = serial;
    },
    removeAll(state, data) {
        var serial = [... state.dataProduct]
        if (data.value) {
            serial[data.index].allSelected = serial[data.index].listSelected
        } else {
            serial[data.index].allSelected = []
        }
        state.dataProduct = serial;
    },
    loadMoreSerial(state, data) {
        var serialData = []
        var listLength = []
        var serialtoAdd = []
        var serial = state.dataProduct
        if (data.type === 'list') {
            serialData = serial[data.index].filteredSerial.length > 0 ? serial[data.index].filteredSerial : serial[data.index].allSerial
            listLength = serial[data.index].serial.length
            serialtoAdd = serialData.slice(listLength , listLength + 10)
            serial[data.index].serial = serial[data.index].serial.concat(serialtoAdd)
        } else {
            serialData = serial[data.index].filteredSerialSelected.length > 0 ? serial[data.index].filteredSerialSelected : serial[data.index].allSelected
            listLength = serial[data.index].listSelected.length
            serialtoAdd = serialData.slice(listLength , listLength + 10)
            serial[data.index].listSelected = serial[data.index].listSelected.concat(serialtoAdd)
        }
    },

    cariSerial( state , index) {
        state.dataProduct[index].filteredSerial = []
        state.dataProduct[index].serial = []
        let data = state.dataProduct[index]
        let serial = data.allSerial
        let letsTry = (data, serial) => {
            return new Promise( (resolve) => {
                let result = serial
                if (data.serialMin && data.serialMax) {
                    result = serial.filter( (el) => {
                        return data.serialMin.localeCompare(el) <= 0 && data.serialMax.localeCompare(el) >= 0
                    })
                }
                resolve(result)
            })
        }
        setTimeout(function(){
            letsTry(data, serial).then( res => {
                if (res.length > 0) {
                    state.dataProduct[index].filteredSerial = res
                    state.dataProduct[index].serial = res.slice(0, 100)
                } else {
                    state.dataProduct[index].serial = 'error'
                }
            })
        }, 500)
    },
    async setDataCheckSerial(state, data) {
        var product = await state.dataProduct
        data.serial_valid.forEach( (el) => {
            let serialInclude = []
            product.forEach(elProduct => {
                serialInclude = [...serialInclude , ...elProduct.listSelected]
            })
            let index_serial = product.findIndex(element => element.type_id == el.type && element.listSelected.length < element.totalNeeded)
            if (index_serial != -1) {
                if (!serialInclude.includes(el.serial)) {
                    product[index_serial].listSelected.push(el.serial)
                } else {
                    state.ProsesOrderAlert = `Serial ${el.serial} sudah digunakan`
                }
            } else {
                let index_type_match = product.findIndex(element => element.type_id == el.type)
                if (index_type_match == -1) {
                    state.ProsesOrderAlert = `Tidak ditemukan produk yang sesuai`
                } else {
                    state.ProsesOrderAlert = `Serial yang dibutuhkan sudah mencukupi`
                }
            }
        });
        if (data.serial_valid.length == 0) {
            state.ProsesOrderAlert = 'Serial tidak tersedia'
        }
    },
};

const actions = {
    putActPickUp({ commit, dispatch }, params) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.actPickup(params).then(() => {
            commit(PROGRESS_FINISH, null, { root: true });
            commit('resetAlertKonfPickUp')
            dispatch('list');
        }).catch((err) => {
            const { data } = err.response.data;
            commit('setAlertKonfPickUp', data)
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    postNoResi({ commit, dispatch }, params) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.actNoResi(params).then(() => {
            commit(PROGRESS_FINISH, null, { root: true });
            commit('resetAlertKonfPickUp')
            dispatch('list');
        }).catch((err) => {
            const { data } = err.response.data;
            if (err.response.message == 'error_validation') {
                commit('setAlertKonfPickUp', data)
            } else {
                commit('setAlertKonfPickUp', err.response.message)
            }
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    putProsesOrder({ commit, dispatch }, params) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.ApprovalOrder(params).then(() => {
            dispatch('list');
            dispatch('getOneTransaction', state.transactionOne.trx_id);
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            commit('errorProsesOrder', err.response.data.message)
        });
    },

    list({ commit, dispatch }) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.list().then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listTransaction', { data: 'error', pagination: data.pagination });
            } else {
                commit('listTransaction', { data: data.results, pagination: data.pagination });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getTransactions({ commit }, params) {
        commit(PROGRESS_START, null, { root: true });
        let parameterObject = {}
        let parameter = '{'
        params.params.forEach((value, index) => {
            for (const [key, val] of Object.entries(value)) {
                parameter += `"filter[${index}][${key}]":"${encodeURI(val)}",`
            }
        });
        parameter += `"limit": ${params.limit}, "page": ${params.page}`
        parameter += '}'
        parameterObject = JSON.parse(parameter)
        transactionApi.list(parameterObject).then(({ data: { data } }) => {
            if (data.results.length == 0) {
                commit('listTransaction', { data: 'error', pagination: data.pagination });
            } else {
                commit('listTransaction', { data: data.results, pagination: data.pagination });
            }
            commit(PROGRESS_FINISH, null, { root: true });
        })
    },

    getSerialOwnedList({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        stockApi.getDataStockSerial(value).then(({ data: { data } }) => {
            commit('setSerialOwnedList', data.results)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    checkSerialMLM({ commit }, value) {
        commit(PROGRESS_START, null, { root: true });
        transactionApi.checkSerialMLM(value).then(({ data: { data } }) => {
            commit('setDataCheckSerial', data.results)
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch(() => {
            commit('errorProsesOrder', 'Serial tidak tersedia')
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    getOneTransaction({ commit, dispatch }, value) {
        commit('listTransactionOne', {});
        commit(PROGRESS_START, null, { root: true });
        transactionApi.detail(value).then(({ data: { data } }) => {
            commit('listTransactionOne', data);
            if (data.trx_status == 3) {
                let list_product = []
                data.products.forEach(product => {
                    if (product.serial && product.serial != 0) {
                        let is_serial = JSON.parse(product.serial)
                        is_serial.forEach(data => {
                            data.product = product
                            data.allSelected = [];
                            data.listSelected = [];
                            data.removeAll = false;
                            data.totalNeeded = data.quantity * product.quantity

                            list_product.push(data)
                        })
                    }
                });
                commit('listProduct', list_product)
            }
            commit(PROGRESS_FINISH, null, { root: true });
        }).catch((err) => {
            const { data } = err.response;
            dispatch('errorHandler', data);
            commit(PROGRESS_FAIL, null, { root: true });
        });
    },

    scanLinkSerial({ commit, dispatch }, value) {
        return new Promise((resolve) => {
            commit(PROGRESS_START, null, { root: true });
            scanSerialApi.scanLinkSerial(value).then((res) => {
                const data = res.data;
                resolve(data)
                commit(PROGRESS_FINISH, null, { root: true });
            }).catch((err) => {
                const { data } = err.response.data;
                dispatch('errorHandler', data);
                commit(PROGRESS_FAIL, null, { root: true });
            });
        })
    },

    errorHandler({ commit }, response) {
        commit('failed', { type: 'error', message: response.message });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,

};